import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 120;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: null },
  { prop: 'takeApartOrgName', label: '拆包组织名称', width: null },
  { prop: 'packageName', label: '包名称', width: null },
  { prop: 'packageType', label: '运输类型', width: null },
  { prop: 'waybillNo', label: '包签号', width: null },
  { prop: 'ext1', label: '一段码', width: null },
  { prop: 'rePrintTime', label: '补打时间', width: null }
];

const searchResultTableHeader: TableHeaderItem[] = [
  { prop: 'waybillNo', label: '包签号', width: null },
  { prop: 'ext1', label: '一段码', width: null },
  { prop: 'takeApartOrgName', label: '拆包组织名称', width: null },
  { prop: 'packageName', label: '包名称', width: null }
];

export default { tableHeader, searchResultTableHeader }
